import i from "./component-library145.js";
/* empty css                     */
import r from "./component-library98.js";
var a = function() {
  var e = this, t = e._self._c, s = e._self._setupProxy;
  return t("div", { staticClass: "prices", class: s.themeClass }, [e.title ? t(s.Heading, { staticClass: "prices__heading", attrs: { size: "sm", tag: "h4" } }, [e._v(" " + e._s(e.title) + " ")]) : e._e(), t("div", { staticClass: "prices__main" }, [e.isPrice ? t(s.Price, { staticClass: "prices__is-price", attrs: { "is-highlight": "", theme: e.theme, amount: e.isPrice, "pre-text": e.preTextIsPrice, "post-text": e.postTextIsPrice, variant: e.variant, "is-price-bold": e.isPriceBold } }) : e._e(), e._t("footnote"), e.wasPrice ? t(s.Price, { staticClass: "prices__was-price", attrs: { amount: e.wasPrice, "is-was-price": "", "pre-text": e.preTextWasPrice, "post-text": e.postTextWasPrice, variant: e.variant, theme: e.theme, "is-price-bold": e.isWasPriceBold } }) : e._e()], 2)], 1);
}, c = [], _ = /* @__PURE__ */ r(
  i,
  a,
  c,
  !1,
  null,
  "45a21da9"
);
const m = _.exports;
export {
  m as default
};
